import { useUser } from "../../context/UserContext";
import { Navigate } from "react-router-dom";
import LoadingComponent from "../loading/LoadingComponent"
import { homePath } from "../utils/homePath";

const ProtectedRoute = ({ element, requiredPermissions }) => {
    const { user, loading } = useUser();

    if (loading) {
        return <LoadingComponent />; // Mostrar un spinner mientras carga el usuario
    }

    if (!user) {
        return <Navigate to="/" replace />; // El login está en "/"
    }

    if (requiredPermissions && !requiredPermissions.every(perm => user.authorities.includes(perm))) {
        // Sin permiso para esta pantalla: a su página de inicio, sin cerrar la sesión
        return <Navigate to={homePath(user)} replace />;
    }

    return element; // Renderiza el componente si el usuario está autenticado y tiene permisos
};

export default ProtectedRoute;
